import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ILoadBulkImportEmployeesResponse } from '../models/bulk-import-employees.model';

export const undoBulkEmployeeUpdatesKey = 'undoBulkEmployeeUpdates';

export interface UndoBulkEmployeeUpdatesState {
  undoBulkEmployeeUpdatesResponse: any;
  undoBulkEmployeeUpdatesFailure: any;
  loaded: boolean;
}

export const initialState: UndoBulkEmployeeUpdatesState = {
  undoBulkEmployeeUpdatesResponse: undefined,
  undoBulkEmployeeUpdatesFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.undoBulkEmployeeUpdatesSuccess, (state, action) => ({
    ...state,
    undoBulkEmployeeUpdatesResponse: action.response,
    loaded: true
  })),

  on(actions.undoBulkEmployeeUpdatesFailure, (state, action) => ({
    ...state,
    undoBulkEmployeeUpdatesFailure: action.error
  }))
);

export const undoBulkEmployeeUpdates = (state: UndoBulkEmployeeUpdatesState) => state.undoBulkEmployeeUpdatesResponse;
